import API from "../global/api";

// Getting Get Invoices List
export const getAdminDashboardCredentialsRequest = () => {
  return {
    type: "GET_ADMIN_DASHBOARD_CREDENTIALS_REQUEST",
  };
};
export const getAdminDashboardCredentialsSuccess = (data) => {
  return {
    type: "GET_ADMIN_DASHBOARD_CREDENTIALS_SUCCESS",
    payload: data,
  };
};
export const getAdminDashboardCredentialsError = (msg) => {
  return {
    type: "GET_ADMIN_DASHBOARD_CREDENTIALS_ERROR",
    payload: msg,
  };
};
export const getAdminDashboardCredentials = () => {
  return (dispatch) => {
    dispatch(getAdminDashboardCredentialsRequest());
    API.get(`/user/admin-dashboard`)
      .then((res) => {
        let getAdminCredentials = res.data;
        dispatch(getAdminDashboardCredentialsSuccess(getAdminCredentials));
      })
      .catch((error) => {
        dispatch(
          getAdminDashboardCredentialsError(error?.response?.data?.message),
        );
      });
  };
};

// Getting Admin Dashboard Invoice Count by Companies
export const getAdminDashboardInvoiceCountByCompaniesRequest = () => {
  return {
    type: "GET_ADMIN_DASHBOARD_INVOICE_COUNT_BY_COMPANIES_REQUEST",
  };
};
export const getAdminDashboardInvoiceCountByCompaniesSuccess = (data) => {
  return {
    type: "GET_ADMIN_DASHBOARD_INVOICE_COUNT_BY_COMPANIES_SUCCESS",
    payload: data,
  };
};
export const getAdminDashboardInvoiceCountByCompaniesError = (msg) => {
  return {
    type: "GET_ADMIN_DASHBOARD_INVOICE_COUNT_BY_COMPANIES_ERROR",
    payload: msg,
  };
};
export const getAdminDashboardInvoiceCountByCompanies = (page, limit) => {
  return (dispatch) => {
    dispatch(getAdminDashboardInvoiceCountByCompaniesRequest());
    API.get(`/invoice/invoice-count-by-companies?page=${page}&limit=${limit}`)
      .then((res) => {
        let getAdminInvoicesByCompanies = res.data;
        dispatch(getAdminDashboardInvoiceCountByCompaniesSuccess(getAdminInvoicesByCompanies));
      })
      .catch((error) => {
        dispatch(
          getAdminDashboardInvoiceCountByCompaniesError(error?.response?.data?.message),
        );
      });
  };
};
